import { render, staticRenderFns } from "./SegmentSteam.vue?vue&type=template&id=3c8702d4&scoped=true&"
import script from "./SegmentSteam.vue?vue&type=script&lang=js&"
export * from "./SegmentSteam.vue?vue&type=script&lang=js&"
import style0 from "./SegmentSteam.vue?vue&type=style&index=0&id=3c8702d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8702d4",
  null
  
)

export default component.exports